import { KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { removeEmptyParagraphs } from '../../commons/preprocess-paragraphs';
import { buildDrupalImage } from '../Image';

function isImage(
  input: CarouselImageFragment | CarouselVideoFragment,
): input is CarouselImageFragment {
  return input?.__typename === 'ParagraphImageWithCaption';
}

export function mapCarousel(
  input: CarouselFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'ImageCarousel'> {
  return {
    key: 'ImageCarousel',
    input: {
      display: input.display || '',
      lightboxImages:
        removeEmptyParagraphs(input.items)
          .filter(cleanList)
          .filter(isImage)
          .map((item) => {
            return {
              Image: buildDrupalImage(item.image, 'content'),
              description: item.caption,
            };
          }) || [],
      images:
        removeEmptyParagraphs(input.items)
          .filter(cleanList)
          .filter(isImage)
          .map((item) => {
            return {
              Image: buildDrupalImage(item.image, 'image_gallery'),
              description: item.caption,
            };
          }) || [],
    },
  };
}
